const POPUP_WIDTH = 500
const POPUP_HEIGHT = 700
const CLOSED_POLL_INTERVAL_MS = 500

// Plain-JS counterpart to client/src/hooks/use_popup_auth.js, for legacy
// class components that can't consume hooks. Opens AuthKit in a popup;
// invokes onSuccess / onError after receiving a postMessage from
// /users/auth/workos/popup_callback. Returns a cancel function the caller
// can invoke during unmount.
export default function openWorkosAuthPopup({ returnTo, onSuccess, onError }) {
  const left = window.screen.width / 2 - POPUP_WIDTH / 2
  const top = window.screen.height / 2 - POPUP_HEIGHT / 2
  const features = `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top}`
  const popup = window.open("about:blank", "wos-auth", features)

  if (!popup) {
    onError(
      "Popup was blocked. Please allow popups for this site and try again."
    )
    return () => {}
  }

  const url = `/users/sign_in/popup${
    returnTo ? `?return_to=${encodeURIComponent(returnTo)}` : ""
  }`
  popup.location.href = url

  let pollId = null
  let finished = false

  const cleanup = () => {
    if (finished) return
    finished = true
    if (pollId) clearInterval(pollId)
    window.removeEventListener("message", handleMessage)
  }

  function handleMessage(event) {
    if (event.origin !== window.location.origin) return
    if (event.source !== popup) return
    const { type, message } = event.data || {}
    if (type === "workos:auth:success") {
      popup.close()
      cleanup()
      onSuccess()
    } else if (type === "workos:auth:error") {
      popup.close()
      cleanup()
      onError(message || "Authentication failed")
    }
  }

  window.addEventListener("message", handleMessage)

  pollId = setInterval(() => {
    if (popup.closed) {
      cleanup()
      onError("Sign in cancelled")
    }
  }, CLOSED_POLL_INTERVAL_MS)

  return cleanup
}
